
  import '/home/ec2-user/Youlify-Design/components/progress/index.$tab-design.zh-CN.md?watch=parent';
  export const texts = [{"value":"Progress 的本质是了解任务的进度","paraId":0,"tocIndex":0}];
  